module.exports = __webpack_public_path__ + "img/works_xikemu_dx_2.f8e7441a.png";